/**
 * Task 216 — the lazy boundary for the connections graph.
 *
 * This is the ONLY connections file App.tsx imports. The 3D view (and with it
 * 3d-force-graph + three.js, ~hundreds of KB) loads via dynamic import() so the
 * chat/reader bundles are untouched and only /conexiones pays the cost. Nothing
 * outside the lazy chunk may import 3d-force-graph (three.js also breaks under
 * node, so hermetic smokes must never touch it).
 */
import { Suspense, lazy, type JSX } from "react";
import type { CorpusRoute } from "../corpus/use-corpus-route";
import type { Language } from "../strings";
import type { Strings } from "../strings/types";

const ConnectionsView = lazy(() => import("./ConnectionsView"));

export interface ConnectionsRouteProps {
  route: CorpusRoute;
  navigate: (to: string) => void;
  language: Language;
  onLanguage: (lang: Language) => void;
  strings: Strings;
  onAsk: (prompt: string) => void;
  /** Task 224: open the shared About dialog (unified topbar). */
  onAbout: () => void;
}

export function ConnectionsRoute(props: ConnectionsRouteProps): JSX.Element {
  return (
    <Suspense
      fallback={
        <div className="cgraph cgraph--loading">
          <p className="creader-note">{props.strings.connectionsLoading}</p>
        </div>
      }
    >
      <ConnectionsView {...props} />
    </Suspense>
  );
}
